import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import { useState } from "react";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

export default function BoltBuild({ data }) {
  const [activeKey, setActiveKey] = useState(0);
  const dispatch = useDispatch();

  return (
    <div className="home-labtool">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="telemed-feature-head">
              <h3 className="heading center-heading">
                {data && data.titlePart1} <span className="gradiant-color">{data && data.titlePart2}</span>
              </h3>
              <p className="sub-heading">{data && data.description}</p>
            </div>
          </div>

          <div className="col-lg-12">
            <Tab.Container id="left-tabs-example" activeKey={activeKey}>
              <div className="row">
                <div className="col-lg-4 col-md-5">
                  <Nav className="flex-column labtab-link telemed-feature-link">
                    {data && data.tabs.map((tab, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link onMouseEnter={() => setActiveKey(index)}>
                          <div>
                            <img src={tab.icon} alt="icon" loading="lazy" className="img-responsive" />
                            <h4>{tab.title}</h4>
                          </div>
                          <span>{`0${index + 1}`}</span>
                          <img src="/assets/home/labarrow.webp" className="lab-arrow" alt="icon" loading="lazy"/>
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </div>

                <div className="col-lg-8 col-md-7">
                  <Tab.Content className="labtab-content telemed-feature-content">
                    { data && data.tabs.map((tab, index) => (
                      <Tab.Pane eventKey={index} key={index}>
                        <img loading="lazy" src={tab.image} alt="bolt build" className="img-responsive"/>
                        <h4>{tab.title}</h4>
                        <p>{tab.description}</p>
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </div>

                <div className="col-lg-12 mt-4 text-center">
                  <Link to={"/features/taxi-software"} className="default-btn">{data && data.btn}</Link>
                </div>
              </div>
            </Tab.Container>
          </div>
        </div>
      </div>
    </div>
  );
}
